import React from 'react';
import { Link } from 'react-router-dom';
import { ShoppingCart } from 'lucide-react';
import { Button } from './ui/button';
import { useCart } from '../context/CartContext';
import { useAuth } from '../context/AuthContext';
import { toast } from 'sonner';

const ProductCard = ({ product }) => {
  const { addToCart } = useCart();
  const { user } = useAuth();

  const handleAddToCart = async () => {
    if (!user) {
      toast.error('Please login to add items to cart');
      return;
    }

    try {
      await addToCart(product.id, 1);
      toast.success('Added to cart!');
    } catch (error) {
      toast.error('Failed to add to cart');
    }
  };

  return (
    <div
      className="bg-white border border-slate-200 rounded-sm shadow-sm hover:shadow-xl hover:border-secondary/50 transition-all duration-300 group relative overflow-hidden"
      data-testid="product-card"
    >
      <Link to={`/products/${product.id}`}>
        <div className="aspect-square overflow-hidden bg-slate-100">
          <img
            src={product.images?.[0] || 'https://images.unsplash.com/photo-1615746363486-92cd8c5e0a90?w=400'}
            alt={product.name}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
          />
        </div>
      </Link>

      <div className="p-4">
        <Link to={`/products/${product.id}`}>
          <h3 className="font-heading text-lg font-bold text-primary mb-2 line-clamp-2 uppercase tracking-tight">
            {product.name}
          </h3>
        </Link>
        <p className="text-sm text-slate-600 mb-3 line-clamp-2">{product.description}</p>

        <div className="flex items-center justify-between">
          <span className="text-2xl font-bold text-secondary">
            ₹{product.price.toFixed(2)}
          </span>
          <Button
            onClick={handleAddToCart}
            size="sm"
            className="gap-2"
            data-testid="add-to-cart-button"
          >
            <ShoppingCart className="h-4 w-4" />
            Add
          </Button>
        </div>

        {product.stock <= 10 && product.stock > 0 && (
          <p className="text-xs text-orange-600 mt-2">Only {product.stock} left!</p>
        )}
        {product.stock === 0 && (
          <p className="text-xs text-red-600 mt-2 font-bold">Out of Stock</p>
        )}
      </div>
    </div>
  );
};

export default ProductCard;